if (!customElements.get('linked-product-slider')) {
  customElements.define(
    'linked-product-slider',
    class LinkedProductSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-slider-viewport]');
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.controls = this.querySelector('[data-slider-controls]');

        if (!this.viewport || !this.previousButton || !this.nextButton) return;

        this.handlePrevious = () => this.scrollByCard(-1);
        this.handleNext = () => this.scrollByCard(1);
        this.updateControls = () => this.setControlState();

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.viewport.addEventListener('scroll', this.updateControls, { passive: true });

        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.viewport);
        this.setControlState();
      }

      disconnectedCallback() {
        if (!this.viewport) return;

        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.viewport.removeEventListener('scroll', this.updateControls);
        this.resizeObserver?.disconnect();
      }

      scrollByCard(direction) {
        const card = this.querySelector('[data-slider-card]');
        if (!card) return;

        const track = this.querySelector('.linked-product-slider__track');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const rtlMultiplier = document.documentElement.dir === 'rtl' ? -1 : 1;

        this.viewport.scrollBy({
          left: direction * rtlMultiplier * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      }

      setControlState() {
        const viewportRect = this.viewport.getBoundingClientRect();
        const cards = this.querySelectorAll('[data-slider-card]');
        const firstCard = cards[0];
        const lastCard = cards[cards.length - 1];
        const hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 1;

        if (this.controls) this.controls.hidden = !hasOverflow;
        if (!firstCard || !lastCard) return;

        const firstRect = firstCard.getBoundingClientRect();
        const lastRect = lastCard.getBoundingClientRect();
        const isRtl = document.documentElement.dir === 'rtl';

        this.previousButton.disabled = isRtl
          ? lastRect.right <= viewportRect.right + 1
          : firstRect.left >= viewportRect.left - 1;
        this.nextButton.disabled = isRtl
          ? firstRect.left >= viewportRect.left - 1
          : lastRect.right <= viewportRect.right + 1;
      }
    }
  );
}
